import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { P500UIButtonsModule, P500UIIconsModule } from '@platform500services/p500-ui-kit';
import { CurrentTimeModule } from '../current-time/current-time.module';
import { FieldsModule } from '../fields/fields.module';
import { HelloWidgetSidebarComponent } from './hello-widget-sidebar.component';
import { SwitchAccountWidgetModule } from "../switch-account-widget/switch-account-widget.module";

@NgModule({
  imports: [CommonModule, P500UIIconsModule, FieldsModule, CurrentTimeModule, P500UIButtonsModule, SwitchAccountWidgetModule],
  declarations: [HelloWidgetSidebarComponent],
  exports: [HelloWidgetSidebarComponent],
})
export class HelloWidgetSidebarModule {}
